import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UploadEvent, UploadFile } from "ngx-file-drop";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { timer } from "rxjs/observable/timer";
import { Subscription } from "rxjs/Subscription";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  moduleId: module.id,
  templateUrl: "refund.component.html",
})
export class RefundComponent implements OnInit, OnDestroy {
  model: any = {};
  loading = false;
  messages: any;
  refundItem: any;
  files: UploadFile[] = [];
  manualFiles: { originalFile: string; fileName: string; status: number }[] =
    [];
  fileUploadStatus: { status: number }[] = [];
  fileErr = false;
  fileNameErr: string;
  timerSubs: Subscription[] = [];
  manualTimerSubs: Subscription[] = [];
  formData: FormData;
  allowedTypes: ["doc", "docx", "jpg", "jpeg", "pdf", "tif", "tiff", "png"];
  modalReference: any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    //         private httpClient: HttpClient,
    private alertService: AlertService
  ) {
    this.refundItem = localStorage.getItem("refundItem");
    if (!this.refundItem) this.router.navigate(["/"]);
    else {
      this.refundItem = JSON.parse(this.refundItem);
    }
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  meshutafRefundOk() {
    this.modalReference.close();
    this.router.navigate(["/"]);
  }

  sendRequest(modalContent?: any) {
    if (!this.loading) {
      this.loading = true;
      this.dataService
        .refundRequest({
          refundRequest: this.model,
          item: this.refundItem,
        })
        .subscribe(
          (data) => {
            this.loading = false;

            if (this.refundItem && data.paymentReturnId) {
              this.sendFiles(data.paymentReturnId, this.refundItem.childId);
            }
            if (this.refundItem.isMeshutaf == 1 && modalContent) {
              let options: NgbModalOptions = {
                windowClass: "refund-meshutaf-modal",
                backdrop: "static",
              };
              this.modalReference = this.modalService.open(
                modalContent,
                options
              );
            } else {
              this.alertService.success("הבקשה נשלחה בהצלחה!!!", true);
              this.router.navigate(["/"]);
            }
          },
          (error) => {
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.messages[body.statusText]
                  ? this.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
            this.loading = false;
          }
        );
    }
  }

  sendFiles(eventId, childId) {
    let filesForUpload = new FormData();
    let mCounter = 0;
    this.manualFiles.forEach((manualFile) => {
      filesForUpload.append(
        "uploadedFile" + mCounter++,
        manualFile.originalFile,
        manualFile.fileName
      );
    });
    this.files.forEach((fileOfFiles) => {
      const fileEntry = fileOfFiles.fileEntry;

      fileEntry.file((file: File) => {
        filesForUpload.append(
          "uploadedFile" + mCounter++,
          file,
          fileOfFiles.relativePath
        );
      });
    });
    setTimeout(() => {
      //              if ((this.manualFiles && this.manualFiles.length > 0) || (this.files && this.files.length > 0)) {
      this.dataService.sendFiles(filesForUpload, eventId, childId).subscribe(
        (data) => {
          this.manualFiles = [];
          this.files = [];
        },
        (error) => {
          console.error(error);
        }
      );
      // 	        }
    }, 1000);
  }

  ngOnInit() {
    // 	    this.formData = new FormData();
  }

  ngOnDestroy() {
    this.timerSubs.forEach((timerSub) => timerSub.unsubscribe());
    this.manualTimerSubs.forEach((timerSub) => timerSub.unsubscribe());
  }

  dropped(event: UploadEvent) {
    for (const file of event.files) {
      if (
        this.getFileExtension(file) === "png" ||
        this.getFileExtension(file) === "jpg" ||
        this.getFileExtension(file) === "jpeg" ||
        this.getFileExtension(file) === "pdf" ||
        this.getFileExtension(file) === "doc" ||
        this.getFileExtension(file) === "tif" ||
        this.getFileExtension(file) === "tiff" ||
        this.getFileExtension(file) === "docx"
      ) {
        this.files.push(file);
        this.fileUploadStatus.push({ status: 0 });
        this.uploadAnimation(
          this.fileUploadStatus.length - 1,
          this.fileUploadStatus[this.fileUploadStatus.length - 1]
        );
        //         this.formData.append('uploadFile', file.fileEntry, file.fileEntry.name);
        this.fileErr = false;
      } else {
        this.fileErr = true;
        this.fileNameErr =
          file.fileEntry.name + "." + this.getFileExtension(file);
      }
    }
  }

  uploadAnimation(fileIndex: number, fileUpload: { status: number }): void {
    const t = timer(2000, 1000);
    // fileStatus
    this.loading = true;
    this.timerSubs[fileIndex] = t.subscribe((_) => {
      fileUpload.status += 25;
      if (fileUpload.status === 100) {
        this.loading = false;
        this.timerSubs[fileIndex].unsubscribe();
      }
    });
  }

  uploadAnimationManual(
    fileIndex: number,
    fileUpload: { originalFile: string; fileName: string; status: number }
  ): void {
    const t = timer(2000, 1000);
    // fileStatus
    this.loading = true;
    this.manualTimerSubs[fileIndex] = t.subscribe((_) => {
      fileUpload.status += 25;
      if (fileUpload.status === 100) {
        this.loading = false;
        this.manualTimerSubs[fileIndex].unsubscribe();
      }
    });
  }

  removeFile(file: UploadFile): void {
    const idx = this.files.indexOf(file);
    this.files.splice(idx, 1);
    this.timerSubs[idx].unsubscribe();
    this.fileUploadStatus.splice(idx, 1);
  }

  removeManualFile(file: {
    originalFile: string;
    fileName: string;
    status: number;
  }): void {
    const idx = this.manualFiles.indexOf(file);
    this.manualFiles.splice(idx, 1);
    this.manualTimerSubs[idx].unsubscribe();
  }

  manualUpload(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      const fileName = this.getFileName(fileInput.srcElement.value);
      reader.onload = function (e: any) {
        const newFile = {
          originalFile: fileInput.target.files[0],
          fileName: fileName,
          status: 0,
        };

        this.manualFiles.push(newFile);
        this.uploadAnimationManual(this.manualFiles.length - 1, newFile);
      }.bind(this);
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  getFileName(fullPath): string {
    return fullPath.split(/(\\|\/)/g).pop();
  }

  getFileExtension(file: UploadFile): string {
    const name = file.fileEntry.name;
    const extensionArr = name.split(".");
    const extension = extensionArr[extensionArr.length - 1];
    return extension;
  }

  getManualFileExtension(file: {
    originalFile: string;
    fileName: string;
    status: number;
  }): string {
    const name = file.fileName;
    const extensionArr = name.split(".");
    const extension = extensionArr[extensionArr.length - 1];
    return extension;
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/refund.component.ts